const VITESSE_APIS = {
  transactions: {
    desc: 'Transactions API (legacy)',
  },
  payment_requests: {
    desc: 'Payment Requests API',
  },
} as const;

export default VITESSE_APIS;
